import type { ReactElement } from 'react';

import STYLES from './GlobalNavigationEmptyCard.module.scss';

export const GlobalNavigationEmptyCard = (): ReactElement => (
  <div className={STYLES.container}>
    <div className={STYLES.emptyCard} role="none" />
  </div>
);
